import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import DataTable from 'react-data-table-component';
import UserSidebar from "../includes/sidebar";


export default function Membership({ user }) {

    const loading = useSelector((state) => state.referral.loading);
    const [referralData, setReferralData]= useState(user || {});
    const referralsStateData = useSelector((state) => state.referral.referrals);

    const columns = [
        
        { name: 'Name', selector: row => row.userData[0]?.fullName, sortable: true, },
        { name: 'Email', selector: row => row.userData[0]?.email, sortable: true, },
        { name: 'Membership', selector: row => row.userData[0]?.phone, sortable: true, },
        { name: 'Expiry', selector: row => row.expiry, sortable: true, },
        {
            name: 'Payment', selector: row => row.payment, sortable: true,
        }

    ];

    const [searchText, setSearchText] = useState('');
    const handleSearch = e => {
        setSearchText(e.target.value.toLowerCase());

    };

    const handleResetSearch = () => {
        setSearchText('');
    };

    const filteredData = referralsStateData?.filter(item =>
        Object.values(item).some(value =>
            value.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    return (
        <div className="main-container">
            <UserSidebar user={user} />
            {/* App container starts */}
            <div className="app-container">
                {/* App hero header starts */}
                <div className="app-hero-header mb-4"></div>
                {/* App Hero header ends */}
                {/* App body starts */}
                <div className="app-body">
                    {/* Row start */}
                    <div className="row gx-3">
                        <div className="col-12">
                            {/* Row start */}
                           
                            {/* Row end */}
                            <div className="card mb-3">
                                <div className="card-header">
                                    <h4 className="card-title">My Membership</h4>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="border-dark rounded-3">
                                            <div className="input-group mb-3 w-25" style={{ float: 'right' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search"
                                                    aria-label="Search"
                                                    aria-describedby="searchButton"
                                                    value={searchText}
                                                    onChange={handleSearch}
                                                />
                                                <button className="btn btn-danger" type="button" id="searchButton" onClick={handleResetSearch}>X</button>
                                            </div>

                                            {loading ? "loading..." :
                                                <DataTable
                                                    columns={columns}
                                                    data={filteredData}
                                                    pagination
                                                    paginationTotalRows={filteredData?.length}


                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div>
        </div >

    )
}
